import { useEffect } from "react";
import { getMemberImmunization } from "../../../apiHandler/actions/profile";
import { displayDateFormatter, DataGridCustomPagination } from "../../helpers";
import { Skeleton } from "@material-ui/lab";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "vaccine", headerName: "Vaccination", flex: 1 },
  { field: "date", headerName: "Date", flex: 1 },
  { field: "adminsteredBy", headerName: "Administered By", flex: 1 },
  { field: "address", headerName: "Address", flex: 1 },
];

const Component = (props) => {
  const { vaccination, setVaccination } = props;

  useEffect(() => {
    if (vaccination === null) fetchAllergies();
    // eslint-disable-next-line
  }, []);

  const fetchAllergies = async () => {
    const response = await getMemberImmunization(props.uuid);
    setVaccination(
      response.immunization &&
        response.immunization.map((i) => {
          return {
            id: i.id,
            date: displayDateFormatter(i.date),
            vaccine: i.vaccineCode?.coding[0]?.code,
            adminsteredBy: i.practitioner[0]?.actor?.name[0]?.family,
            address: i.practitioner[0]?.actor?.address[0]?.line,
          };
        })
    );
  };

  return (
    <div>
      {vaccination === null ? (
        <div className="mj-skeleton-container">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : Array.isArray(vaccination) && vaccination.length !== 0 ? (
        <DataGrid
          rows={vaccination}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={5}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      ) : (
        <p className="mj-no-records">No records to display</p>
      )}
    </div>
  );
};

export default Component;
